import { render, staticRenderFns } from "./EntryCard.vue?vue&type=template&id=739f285d&scoped=true"
import script from "./EntryCard.vue?vue&type=script&lang=js"
export * from "./EntryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f285d",
  null
  
)

export default component.exports